module.exports = __webpack_public_path__ + "static/media/Bpp.3f3fb567.webp";